import { render, staticRenderFns } from "./Visitrecord.vue?vue&type=template&id=71352a3c&scoped=true&"
import script from "./Visitrecord.vue?vue&type=script&lang=js&"
export * from "./Visitrecord.vue?vue&type=script&lang=js&"
import style0 from "./Visitrecord.vue?vue&type=style&index=0&id=71352a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71352a3c",
  null
  
)

export default component.exports